import { Button, InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type CompleteModalProps = {
  open: boolean
  onClose: () => void
  onClick: () => void
  loading: boolean
  type?: string
  unset?: boolean
}
export const ConfirmCustomProfileSettingModal: Organism<CompleteModalProps> = ({
  open,
  onClose,
  onClick,
  loading,
  type,
  unset,
}) => {
  const { t } = useTranslation('ownedItemDetail')

  if (!type) return null

  return (
    <OrganismFrame>
      <InformationModal
        open={open}
        onClose={onClose}
        title={t(unset ? 'confirmCancelBackground' : 'confirmSetBackground')}
        content=""
        cancelText={t('close')}
        buttons={
          <Button
            size="large"
            sx={{ width: 212 }}
            onClick={onClick}
            loading={loading}
          >
            {t(unset ? 'allowCancelBackground' : 'allowSetBackground')}
          </Button>
        }
      />
    </OrganismFrame>
  )
}
